import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // Get the current year dynamically
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer mt-10">
      <div className="flex flex-col items-center gap-4">
        <div className="flex gap-4">
          <Link
            to="/terms-privacy"
            className="text-white terms-link"
            onClick={scrollToTop}
          >
            Terms & Privacy
          </Link>
          <Link
            to="/csae"
            className="text-white terms-link"
            onClick={scrollToTop}
          >
            CSAE Policy
          </Link>
        </div>
        <span className="copyright">
          WeLivv, Inc. © {currentYear}. All Rights Reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
